import { createListenerMiddleware } from "@reduxjs/toolkit";
import { createStoryBlockListener } from "./listeners/createStoryBlockListener";

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening(createStoryBlockListener);
// listenerMiddleware.startListening(deleteStoryBlockListener);
